<template>
  <div class="app-container">
    <el-calendar v-model="currday">
      <template v-if="loading == false" slot="dateCell" slot-scope="{ date, data }"
        ><span>{{ date.getDate() }}</span>
        <el-popover placement="top-start" title="当日日程" trigger="hover">
          <p v-for="(mmm, index) in getTodo(date, data)" class="course-p">
            <span>课程：</span> {{ mmm.course_title }} <span>章节：</span>{{ mmm.section_title }} <span>时间：</span
            >{{ mmm.start_time }}~{{ mmm.end_time }}
            <i class="el-icon-search" @click="getDetail(mmm)"></i>
          </p>
          <p v-if="getTodo(date, data)[0]" slot="reference" class="course-text">
            {{ getTodo(date, data)[0].course_title }}
          </p>
        </el-popover>
      </template>
    </el-calendar>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" center>
      <div class="msg">
        <div><label for="">授课导师</label>{{ msg.teacher }}</div>
        <div><label for="">上课时间</label>{{ msg.start_time }}~{{ msg.end_time }}</div>
        <div><label for="">课程名称</label>{{ msg.course_title }}</div>
        <!-- <div><label for="">备注</label>{{ msg.remark }}</div> -->
        <div><label for="">上课地点</label>{{ msg.address }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { teacherSche } from "@/api/teacher.js";
export default {
  data() {
    return {
      msg: {},
      dialogVisible: false,
      currday: new Date().format("yyyy-MM-dd"),
      loading: false,
      list: [
        {
          time: "2021-11-12",
          text: "理论课9:00~12:00,理论课12:00~13:00",
        },
      ],
    };
  },
  watch: {
    currday(newValue, oldValue) {
      const ov = new Date(oldValue);
      if (ov.getMonth() != newValue.getMonth()) {
        const day = newValue.format("yyyy-MM-dd");
        this.getteacherSche(day);
      } else {
        // this.getDetail(newValue)
      }
    },
  },
  mounted() {
    this.getteacherSche(this.currday);
  },
  methods: {
    getDetail(data) {
      this.msg = data;
      this.dialogVisible = true;
      // const mi = this.list.find(item => {
      //     // console.log(item)
      //     return new Date(item.date).getTime() == new Date(day).getTime()
      // })
      // if (mi) {
      //     this.msg = mi.sec_info[0]
      //     this.dialogVisible = true
      // }
    },
    getTodo(date, data) {
      const mi = this.list.find((item) => {
        // console.log(item)
        return item.date == new Date(data.day).format("yyyy-MM-dd");
      });
      if (mi) {
        return mi.sec_info;
        return mi.sec_info
          .map((it) => {
            return it.course_title + " " + it.start_time + "~" + it.end_time;
          })
          .join("<br/>");
      } else {
        return [];
      }

      console.log(mi);
      // if (data.day == '2021-11-12') {
      //     return '理论课9:00~12:00'
      // }
    },
    getteacherSche(day) {
      this.loading = true;
      teacherSche({
        teacher_uuid: this.$route.query.uuid,
        date: day,
        month_type: 1,
      }).then((res) => {
        // console.log(res)
        if (res.date instanceof Array) {
          this.list = res.date.filter((item) => {
            return Array.isArray(item.sec_info) && item.sec_info.length > 0;
          });
          this.loading = false;
          // console.log(this.list)
        }
      });
    },
  },
};
</script>

<style scoped="scoped" lang="less">
p {
}
.msg {
  line-height: 40px;
}
.msg label {
  display: inline-block;
  width: 30%;
}
.course-p {
  line-height: 2;
  border-bottom: 1px solid #f5f5f5;
  // display: flex;
  // justify-content: space-between;
  align-items: center;
  i {
    color: skyblue;
    cursor: pointer;
    float: right;
    margin-top: 5px;
  }
  span {
    white-space: nowrap;
    color: #bbb;
    margin-left: 10px;
  }
}
.course-text {
  font-size: 12px;
  max-height: 80%;
  overflow: hidden;
  background-color: #aadaed;
  border-left: 5px solid #009aff;
  color: #0790ff;
}
</style>
